import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-printdoc',
  templateUrl: './printdoc.component.html',
  styleUrls: ['./printdoc.component.css']
})
export class PrintdocComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
